module.exports = __webpack_public_path__ + "img/activity2.a28b3398.png";